import * as React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

import { cn } from 'src/lib/utils';

const Collapsible = CollapsiblePrimitive.Root;

const { CollapsibleTrigger } = CollapsiblePrimitive;

function CollapsibleContent({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content> & {
  ref?: React.Ref<HTMLDivElement>;
}) {
  return (
    <CollapsiblePrimitive.Content
      ref={ref}
      className={cn(
        'overflow-hidden transition-all duration-200 ease-out',
        'data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down p-1',
        className
      )}
      {...props}
    >
      {children}
    </CollapsiblePrimitive.Content>
  );
}
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
